import { Application, Feature, Functionality } from '@frontend/functionality/types';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { ApplicationBundleUsageLayout } from '../../components/application-bundle-usage-layout/application-bundle-usage-layout.component';
import { checkFeatureRoute, checkLicenseRoutes } from '../utils';
import Consumptions from './consumptions/consumptions.component';
import VendingDashboard from './dashboard/dashboard.component';
import Recycles from './recycles/recycles.component';
import Replenishments from './replenishments/replenishments.component';
import Returns from './returns/returns.component';
import Reviews from './reviews/reviews.component';
import VendingTransactions from './transactions/transactions.component';

const Stock = lazy(() => import('./stock/stock.component'));

export function ApplicationVendingRoutes(functionalities: Functionality[] | null) {
    const routeLicenseCheckResult = functionalities !== null ? checkLicenseRoutes(functionalities, Application.VENDING) : null;

    if (routeLicenseCheckResult && !routeLicenseCheckResult.appEnabled) {
        return null;
    }

    return (
        <Route
            path='vending'
            element={<ApplicationBundleUsageLayout application={Application.VENDING} />}>
            {checkFeatureRoute(Feature.DASHBOARD, routeLicenseCheckResult) && (
                <Route
                    path='dashboard'
                    element={<VendingDashboard />}
                />
            )}
            <Route
                path='stock'
                element={<Stock />}
            />
            <Route
                path='consumptions'
                element={<Consumptions />}
            />
            <Route
                path='replenishments'
                element={<Replenishments />}
            />
            <Route
                path='returns'
                element={<Returns />}
            />
            <Route
                path='recycles'
                element={<Recycles />}
            />
            <Route
                path='reviews'
                element={<Reviews />}
            />
            <Route
                path='transactions'
                element={<VendingTransactions />}
            />
        </Route>
    );
}
